import React from 'react';
import { motion } from 'framer-motion';
import { IMAGES } from '../constants/images';
import { ScrollBacklight } from './ScrollBacklight';
import { useLanguage } from '../context/LanguageContext';
export function Sensory() {
  const {
    t
  } = useLanguage();
  return <section className="py-32 lg:py-48 bg-cream text-chocolate" data-id="element-337" data-mp="2w6nle0t4tktl">
      <div className="max-w-[1400px] mx-auto px-8 lg:px-14 grid lg:grid-cols-12 gap-12 lg:gap-20 items-center" data-id="element-338" data-mp="304ldpci78n17">
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 1
      }} className="lg:col-span-5 lg:order-1 order-2" data-id="element-339" data-mp="23hgnn41i4z9e">
          <div className="flex items-center gap-3 text-caramel text-[10px] tracking-[0.4em] uppercase mb-10" data-id="element-340" data-mp="3nuxu7brifs3e">
            <span className="w-10 h-px bg-caramel/50" data-id="element-341" data-mp="3swn4gp6ws1qf" />
            {t.sensory.eyebrow}
          </div>
          <h2 className="font-serif text-5xl sm:text-6xl lg:text-7xl text-chocolate leading-[0.95] tracking-[-0.02em] font-light" data-id="element-342" data-mp="23dg3hp184ts1">
            {t.sensory.title1}
            <br data-id="element-343" data-mp="1tgbd1d0cic5f" />
            <span className="italic font-extralight" data-id="element-344" data-mp="1tfrxg2y63zuk">{t.sensory.title2}</span>
          </h2>
          <p className="mt-10 text-chocolate/60 leading-[1.8] text-[15px] max-w-md" data-id="element-345" data-mp="1ohqerj4nm2jm">
            {t.sensory.copy}
          </p>

          <div className="mt-12 grid grid-cols-2 gap-x-8 gap-y-6" data-id="element-346" data-mp="1kihlsghfu8p4">
            {t.sensory.specs.map(s => <div key={s.l} data-id="element-347" data-mp="1aqv2dwuy53ba">
                <p className="text-[10px] tracking-[0.3em] uppercase text-chocolate/40 mb-3" data-id="element-348" data-mp="1aq25roppbu6v">
                  {s.l}
                </p>
                <p className="font-serif text-lg text-chocolate font-light" data-id="element-349" data-mp="15tlewmr4b1q3">
                  {s.v}
                </p>
              </div>)}
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 1.02
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 1.2,
        ease: [0.22, 1, 0.36, 1]
      }} className="lg:col-span-7 lg:order-2 order-1 relative group" data-id="element-350" data-mp="wrlx3s8a3tm3">
          <ScrollBacklight tone="cream" data-id="element-351" data-mp="15tfyhkuqyqxr" />
          <div className="relative aspect-[5/4] overflow-hidden bg-warmwhite" data-id="element-352" data-mp="15uhhqclx2jqk">
            <img src={IMAGES.lidInHand} alt="A TARTA lid held to the light — saffiano-textured espresso board with the foil-stamped wordmark" className="w-full h-full object-cover transition-transform duration-[1400ms] group-hover:scale-[1.03]" data-id="element-353" data-mp="19ui0uajynj3y" />
          </div>
          <div className="mt-4 flex items-center justify-between text-[10px] tracking-[0.3em] uppercase text-chocolate/40" data-id="element-354" data-mp="1or92kqh3x6wq">
            <span data-id="element-355" data-mp="1tld958mgncxa">{t.sensory.detailNo}</span>
            <span data-id="element-356" data-mp="22xkhsisyirbo">{t.sensory.detailLabel}</span>
          </div>
        </motion.div>
      </div>
    </section>;
}